<p class="modal-title">Tip Rain</p>
<form (submit)="handleTipRain($event)">
  <app-input-options
    [(value)]="amountS"
    [icon]="sessionService.balanceIconSrc()"
    [placeholder]="'Enter Amount...'"
    [settings]="{
      maskSettings: {
        mask: 'separator.2',
      },
    }"
  />
  <button class="button button--style-yellow h-32 padding-x-12" type="submit">
    Tip Rain
  </button>
</form>

<div class="info">
  <svg-icon class="info--icon" src="assets/icons/shared/info.svg" />
  <p>
    You can choose to donate your balance towards the rain pot. Everyone will
    see your tip in chat. Minimum tip is <span class="info--price-icon"><span><svg-icon [src]="sessionService.balanceIconSrc()" />1.00</span></span>. Tipping rain doesn't make you
    eligible to join it.
  </p>
</div>
